//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      title: "讨论标题"
    };
  }
};